// JoinProgressBadge.js
'use strict';
import { connect } from 'react-redux';

import withRouter from '../component/WithRouter.jsx';

import { push } from '../action/navigationAction.js';
import addModal from '../action/addModal.js';

import getOperationData from '../selector/getOperationData.js';
import getJoinProgress from '../selector/getJoinProgress.js';

import JoinProgressBadge from '../component/JoinProgressBadge.jsx';

const mapStateToProps = (state, { location }) => {
  return {
    progress: getJoinProgress(state),
    kycFailedreasons: getOperationData(state, ['join', 'kyc'], 'failedReasons'),
    location,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    push: (...args) => dispatch(push(...args)),
    addModal: ({ id }) =>
      dispatch(
        addModal({
          id,
          transitionStatus: 'opening',
        })
      ),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(JoinProgressBadge)
);
